import PropTypes from "prop-types";
import { resolveVideoSrc } from "./lib/resolve-video-source";

export function Video({ src }) {
  const resolvedSrc = resolveVideoSrc(src, window.innerWidth);

  if (!resolvedSrc) {
    return null;
  }

  return (
    <video
      preload="metadata"
      muted
      playsInline
      autoPlay
      loop
      poster={src.previewImage.placeholder}
      src={resolvedSrc.url}
    />
  );
}

Video.propTypes = {
  src: PropTypes.object.isRequired,
};
